// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyAKZAhEFpnfws_UwlfrsEgfYvfEQuC_SHI",
  authDomain: "developers-kwiz.firebaseapp.com",
  projectId: "developers-kwiz",
  storageBucket: "developers-kwiz.appspot.com",
  messagingSenderId: "254809338793",
  appId: "1:254809338793:web:cac4184fff99abfdf74ab8"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

export default app